import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Replace with your actual base URL

const AddLoyaltyCard = () => {
    const [formData, setFormData] = useState({
        description: '',
        per_amount: '',
        calculation_on: '',
        no_of_points: '',
        redeem_amount_per_point: '',
        minimum_redeem_points: '',
        birthday_discount: '',
        anniversary_discount: ''
    });

    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        fetch(`${BASE_URL}loyaltycards`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    alert('Loyalty Card added successfully!');
                    navigate('/LoyaltyCardList');
                } else {
                    alert('Failed to add Loyalty Card.');
                }
            })
            .catch((error) => console.error('Error:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Loyalty Card</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-md-6 offset-md-3">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="description"
                                            name="description"
                                            value={formData.description}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="per_amount" className="form-label">Per Amount</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="per_amount"
                                            name="per_amount"
                                            value={formData.per_amount}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="calculation_on" className="form-label">Calculation On</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="calculation_on"
                                            name="calculation_on"
                                            value={formData.calculation_on}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="no_of_points" className="form-label">No. of Points</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="no_of_points"
                                            name="no_of_points"
                                            value={formData.no_of_points}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="redeem_amount_per_point" className="form-label">Redeem Amount Per Point</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="redeem_amount_per_point"
                                            name="redeem_amount_per_point"
                                            value={formData.redeem_amount_per_point}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="minimum_redeem_points" className="form-label">Minimum Redeem Points</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="minimum_redeem_points"
                                            name="minimum_redeem_points"
                                            value={formData.minimum_redeem_points}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="birthday_discount" className="form-label">Birthday Discount (%)</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="birthday_discount"
                                            name="birthday_discount"
                                            value={formData.birthday_discount}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="anniversary_discount" className="form-label">Anniversary Discount (%)</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="anniversary_discount"
                                            name="anniversary_discount"
                                            value={formData.anniversary_discount}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddLoyaltyCard;
